module.exports = __webpack_public_path__ + "static/media/entname_left.07faaa10.svg";